import React from 'react';
import styles from './Performance.module.css';

interface CCL1Component extends React.FC {
  title?: string;
}

const CCL1: CCL1Component = () => {
  return (
    <div>
      <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Metric Description</div>
          <p>
            A perfect curbside experience begins with a fast confirmation (less than one minute) to the customer that someone is working on their order. This metric is calculated by dividing the number of Enhanced Curbside orders claimed in less than or equal to a minute after customer check-in by the total number of Enhanced Curbside orders.
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Supporting Details</div>
          <p>
            Login to ALP prior to clicking the course name or copy &amp; paste the course name below into the search field in ALP once you&apos;ve logged in:
            <br/>
            <a 
              href="https://acehardware.sabacloud.com/Saba/Web_spf/NA9P1PRD003/app/me/learningeventdetail/cours000000000273743?regId=regdw000000005275005" 
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Acehardware.com Enhanced Curbside Pick-up
            </a>
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Goal</div>
          <p>
            94% (all orders are claimed by the store in less than or equal to 1 minute from customer check-in)
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Update Cadence</div>
          <p>
            Metric is current state and updated monthly.
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Learn More</div>
          <p>
            Designate a &apos;point person&apos; for each shift dedicated to fulfilling .com orders. Using a Mobile device with audible alerting and push notifications ensures you can &quot;answer the call&quot; immediately &amp; seamlessly.
            Managing speed &amp; inventory accuracy can directly reduce .com order cancellations &amp; elevate a best-in-class web-to-store experience. Stores must validate new orders quickly &amp; maintain consistent &amp; disciplined inventory management.
            <br/>
            <br/>
            For additional guidance review the{' '}
            <a 
              href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ace Way of Retailing acehardware.com fulfillment Store Procedures
            </a>
          </p>
      </div>
    </div>
  );
};

CCL1.title = 'Enhanced Curbside Orders Claimed <= 1min';
export default CCL1;
